import { render, staticRenderFns } from "./DefaultMobileNav.vue?vue&type=template&id=35634ab5&scoped=true&"
import script from "./DefaultMobileNav.vue?vue&type=script&lang=js&"
export * from "./DefaultMobileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35634ab5",
  null
  
)

export default component.exports